import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback } from 'react';
import { createTransformer } from '@atlassian/commerce-events-core-react';
export { combineBridges, createGasV3EventChannelBridge, createGasV3OperationalEventChannelBridge, createGasV3ScreenEventChannelBridge, createGasV3TrackEventChannelBridge, createGasV3UIEventChannelBridge, withClient } from '@atlassian/commerce-events-bridge-gasv3-react'; // TODO: Make a package for utilitys like this one

var selectInnerMostBreadcrumbName = function selectInnerMostBreadcrumbName(breadcrumbs) {
  var NO_BREADCRUMB_FOUND_NAME = 'none';

  if (breadcrumbs.length <= 0) {
    return NO_BREADCRUMB_FOUND_NAME;
  }

  return breadcrumbs[breadcrumbs.length - 1].name.toString();
};

var breadcrumbsToAttributes = function breadcrumbsToAttributes(breadcrumbs) {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(breadcrumbs.map(function (breadcrumb) {
    var _breadcrumb$attribute;

    return (_breadcrumb$attribute = breadcrumb.attributes) !== null && _breadcrumb$attribute !== void 0 ? _breadcrumb$attribute : {};
  }))));
};

export var getTelemetryGasV3SharedInfo = function getTelemetryGasV3SharedInfo(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var source = selectInnerMostBreadcrumbName(breadcrumbs);
  var attributes = breadcrumbsToAttributes(breadcrumbs); // TODO: Remove the as cast

  return {
    attributes: attributes,
    source: source
  };
};
export var createGasV3EventTransformer = function createGasV3EventTransformer(_ref2) {
  var from = _ref2.from,
      to = _ref2.to,
      useTransformer = _ref2.useTransformer;

  // Gotta be outside the scope otherwise hooks will keep recomputing
  var useGasV3Transformer = function useGasV3Transformer(transformProps) {
    var transform = useTransformer(transformProps);
    return useCallback(function (_ref3) {
      var breadcrumbs = _ref3.breadcrumbs,
          originalPayload = _ref3.payload;
      var source = selectInnerMostBreadcrumbName(breadcrumbs);
      var breadcrumbAttributes = breadcrumbsToAttributes(breadcrumbs);
      var newPartialPayload = transform(originalPayload); // TODO: Remove the as cast

      return _objectSpread(_objectSpread({}, newPartialPayload), {}, {
        attributes: _objectSpread(_objectSpread({}, breadcrumbAttributes), newPartialPayload.attributes),
        source: source
      });
    }, [transform]);
  };

  var ArbitraryEventToConnectedEvent = createTransformer({
    from: from,
    to: to,
    useTransformer: useGasV3Transformer
  });
  return ArbitraryEventToConnectedEvent;
};
export var createGasV3UIEventTransformer = createGasV3EventTransformer;
export var createGasV3TrackEventTransformer = createGasV3EventTransformer;
export var createGasV3OperationalEventTransformer = createGasV3EventTransformer;
export var breadcrumbMountedPayloadToGasV3ScreenEvent = function breadcrumbMountedPayloadToGasV3ScreenEvent(_ref4) {
  var breadcrumbs = _ref4.breadcrumbs;
  var name = selectInnerMostBreadcrumbName(breadcrumbs);
  var attributes = breadcrumbsToAttributes(breadcrumbs);
  return {
    name: name,
    attributes: attributes
  };
};
export var createGasV3ScreenEventTransformer = function createGasV3ScreenEventTransformer(_ref5) {
  var to = _ref5.to,
      breadcrumbMountedEventChannel = _ref5.breadcrumbAPI.breadcrumbMountedEventChannel;
  var BreadcrumbRenderedToScreenEvent = createTransformer({
    from: breadcrumbMountedEventChannel.Listener,
    to: to,
    useTransformer: function useTransformer() {
      return breadcrumbMountedPayloadToGasV3ScreenEvent;
    }
  });
  return BreadcrumbRenderedToScreenEvent;
};